import type {
  YachtCategory,
  YachtPlayerScoreSheet,
  YachtScoreEntry,
} from "../types";
import {
  YACHT_LOWER_CATEGORIES,
  YACHT_UPPER_BONUS_POINTS,
  YACHT_UPPER_BONUS_THRESHOLD,
  YACHT_UPPER_CATEGORIES,
} from "../types";

function sumEntries(
  entries: Readonly<Partial<Record<YachtCategory, YachtScoreEntry>>>,
  categories: readonly YachtCategory[],
): number {
  return categories.reduce(
    (total, category) => total + (entries[category]?.score ?? 0),
    0,
  );
}

export function createEmptyScoreSheet(playerId: string): YachtPlayerScoreSheet {
  return {
    playerId,
    entries: {},
    upperSubtotal: 0,
    upperBonus: 0,
    lowerSubtotal: 0,
    total: 0,
  };
}

export function recomputeScoreSheet(
  playerId: string,
  entries: Readonly<Partial<Record<YachtCategory, YachtScoreEntry>>>,
): YachtPlayerScoreSheet {
  const upperSubtotal = sumEntries(entries, YACHT_UPPER_CATEGORIES);
  const lowerSubtotal = sumEntries(entries, YACHT_LOWER_CATEGORIES);
  const upperBonus =
    upperSubtotal >= YACHT_UPPER_BONUS_THRESHOLD ? YACHT_UPPER_BONUS_POINTS : 0;

  return {
    playerId,
    entries,
    upperSubtotal,
    upperBonus,
    lowerSubtotal,
    total: upperSubtotal + upperBonus + lowerSubtotal,
  };
}

export function isScoreSheetComplete(sheet: YachtPlayerScoreSheet): boolean {
  return Object.keys(sheet.entries).length === 12;
}
